export function useCopyrightMention() {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return computed(() => t("app.copyright", { year }));
}
